import FlatsPage from './flats-page';
import {DataSource} from './constants';
import {getSiblings} from './utils';
import {renderVisualDescriptions} from './get-flats-layout';
import modalForm from './modal-form';
import toggleLocales from './toggle-locales';

const classNames = {
  flats: {
    unavailable: `flat-piece--unavailable`,
    shown: `flat-piece--shown`
  },
  descriptions: {
    shown: `flatography-visual__description--shown`
  }
};

export default class FlatsVisualPage extends FlatsPage {
  constructor() {
    super();
    this.flatsContainer = this.page.querySelector(`#flats-container`);
    this.descriptions = this.page.querySelector(`.flatography-visual__wrap`);
    this.data = [];
    this.availableFlats = [];
    this.availableFlatsNumbers = [];
    this.activeFlatNumber = null;
  }

  init = (locale) => {
    super.init(locale);
    this.loadData(DataSource.FLATS_LIST, this.enableAvailableFlats);
    this.initModals();
    toggleLocales();
  };

  enableAvailableFlats = (data) => {
    const flatsOnSVG = [...this.flatsContainer.querySelectorAll(`a.flat-piece`)]; //get pieces with flats in svg

    if (!flatsOnSVG.length) return;

    const availableNumbers = data.map(item => item[`apt_number`]); //get numbers of available flats from server

    this.availableFlats = flatsOnSVG.filter(flat => availableNumbers.includes(flat.dataset.flat)); //show only available svg pieces
    this.availableFlats.forEach(flat =>  {
      const slug = data.find(item => item[`apt_number`] === flat.dataset.flat).slug;

      flat.setAttribute(`xlink:href`, `/flats/${slug}`);
      flat.classList.remove(classNames.flats.unavailable);
    });

    this.availableFlats[0].classList.add(classNames.flats.shown); //show first flat from array
    this.activeFlatNumber = this.availableFlats[0].dataset.flat;

    this.renderDescriptions(data);
  };

  renderDescriptions(data) {
    //TODO: optimize code, get rid of double filtering
    const filteredData = data.filter(item => {
      return this.availableFlats.some(flat => flat.dataset.flat === item["apt_number"])
    });
    const wrap = document.createElement(`div`);
    const descriptions = renderVisualDescriptions(filteredData, this.activeFlatNumber, this.locale);

    wrap.innerHTML = descriptions;
    this.descriptions.appendChild(wrap);

    this.bindHandlers();
  };

  bindHandlers() {
    this.availableFlats.forEach(flat => {
      flat.addEventListener(`mouseenter`, (e) => {
        this.toggleFlatsVisibility(e.currentTarget);
      });
    });
  };

  toggleFlatsVisibility = (flat) => {
    const {flats, descriptions} = classNames;
    const flatSiblings = getSiblings(flat);
    const description = this.descriptions.querySelector(`.flatography-visual__description[data-flat="${flat.dataset.flat}"]`);
    const descriptionSiblings = getSiblings(description);

    flat.classList.add(flats.shown);
    flatSiblings.forEach(sibling => sibling.classList.remove(flats.shown));

    descriptionSiblings.forEach(sibling => sibling.classList.remove(descriptions.shown));
    description.classList.add(descriptions.shown);
  };

  initModals() {
    modalForm.init();
  }
}
